/*@ngInject*/
const FieldRuleBuilderRepository = function (baseSharedPromiseRepository) {
    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.getAvailableConditionalFieldTemplateIds = function (uiFormTemplateId) {
        var url = '/rest/UIFormTemplate/' + uiFormTemplateId + '/availableConditionalFieldTemplateIds',
            cacheKey = 'fieldRuleBuilderRepository:' + uiFormTemplateId;

        return this.get(cacheKey, url);
    };

};

angular.module('ums.configuration')
    .service('fieldRuleBuilderRepository', FieldRuleBuilderRepository);
